import React, { Component } from "react";
import { Row, Col, Radio, Empty, Modal } from "antd";
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import moment from "moment";
import Qs from "qs";
import DateRange from "@/DateRange";
import { translate } from "$ACTIONS/Translate";
import { AppliedDataModal } from "./AppliedDataModal";

class BonusHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            historyList: [],
            dateRadio: "1", // 时间单选框值
            definedDate: {
                startTime:  moment()
                .day(moment().day() - 6)
                .format("YYYY-MM-DDTHH:mm:ss"),
                endTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
            }, // 自定义时间值
            selectedRecordItem: null,
            showBonusDetailModal: false,
            showDateRangeModal: false,
            isSelfDefined:false
        };
    }
    componentDidUpdate(prevProps) {
        if(prevProps.radioActiveKey !== this.props.radioActiveKey || prevProps.topTabIndex !==this.props.topTabIndex ){
            this.setState({isSelfDefined:false})
        }
    }

    componentWillUnmount() {
        this.setState = ()=>false;
    }

    getDailydealsHistory = () => {
        this.props.setLoading(true);
        console.log("this.state.definedDate:",this.state.definedDate)
        const startDate = moment(this.state.definedDate.startTime).format("YYYY-MM-DDTHH:mm:ss"),
              endDate = moment(this.state.definedDate.endTime).format("YYYY-MM-DDTHH:mm:ss");
        const params = { 
            startDate,
            endDate
        }
        const queryString = Qs.stringify(params);
        get(ApiPort.DailyDealsHistories + "&" + queryString).then((res) => {
            if (res?.isSuccess && res.result?.dailyDealBonusHistory) {
                this.setState({
                    historyList: res.result.dailyDealBonusHistory,
                });
            }
        }).catch((error) => {
            console.log("🚀 ~ BonusHistory ~ get ~ error:", error)
        }).finally(()=>{
            this.props.setLoading(false)
        })
    };

    changeRadio = (e) => {
        const textMap = {
            "1": "Hôm Nay",
            "7": "Trong 7 Ngày",
            "30": "Trong 30 Ngày",
            "0": "Tùy Chỉnh"
        };
        const text = textMap[e.target.value] || "Hôm Nay";
        Pushgtagdata("Promotion_DailyDeal","Filter​ Period​​","Promotion_DailyDeal_C_FilterPeriod​​​​","",
            [
                {customVariableKey: `Promotion_DailyDeal_C_FilterPeriod​​​​​`,                                                                                                                                                            
                customVariableValue: text },
            ]); 
        if (e.target.value == 1) {
            this.setState(
                {
                    dateRadio: e.target.value,
                    definedDate: {
                        startTime: moment()
                            .startOf("day")
                            .format("YYYY-MM-DDTHH:mm:ss"),
                        endTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
                    },
                },
                () => {
                    this.getDailydealsHistory();
                }
            );
        } else if (e.target.value == 0) {
            this.setState({
                showDateRangeModal: true,
                isSelfDefined:false
            });
        } else {
            this.setState(
                {
                    dateRadio: e.target.value,
                    definedDate: {
                        startTime: moment()
                            .day(
                                moment().day() - (parseInt(e.target.value) - 1)
                            )
                            .utcOffset(8)
                            .format("YYYY-MM-DDTHH:mm:ss"),
                        endTime: moment()
                            .utcOffset(8)
                            .format("YYYY-MM-DDTHH:mm:ss"),
                    },
                    isSelfDefined:false
                },
                () => {
                    this.getDailydealsHistory();
                }
            );
        }
    };

    render() {
        const {
            historyList,
            isSelfDefined,
            definedDate
        } = this.state;
        console.log("historyList:",historyList)
        return (
            <div className="bonusHistory">
                <div className="message-button dailyGiftHistoryBtn">
                    <Radio.Group
                        buttonStyle="solid"
                        // className="black-radio"
                        value={this.state.dateRadio}
                        onChange={this.changeRadio}
                    >
                        <Radio.Button value="1">
                            {translate("今天")}
                        </Radio.Button>
                        <Radio.Button value="7">
                            7 {translate("天")}
                        </Radio.Button>
                        <Radio.Button value="30">
                            30 {translate("天")}
                        </Radio.Button>
                        <Radio.Button
                            value="0"
                            onClick={() => {
                                if (
                                    this.state.dateRadio ===
                                    "0"
                                )
                                    this.setState({
                                        showDateRangeModal: true,
                                    });
                            }}
                        >
                            {translate("自定义")}
                        </Radio.Button>
                    </Radio.Group>
                    {isSelfDefined && (
                        <p className="defined-date-description">
                            {translate("从")} 
                            {`${moment(definedDate.startTime).format("DD/MM/YYYY")}`} 
                            {translate("至")} 
                            {`${moment(definedDate.endTime).format("DD/MM/YYYY")}`}
                            <span
                                onClick={() => {
                                    this.setState({
                                        showDateRangeModal: true,
                                    });
                                }}
                            >
                                {translate("更改")}
                            </span>
                        </p>
                    )}
                </div>
                <div className="history-list-wrap has-detail">
                    <Row style={{ fontSize: "16px",fontWeight:"700" }}>
                        <Col span={4}>{translate("交易日期")}</Col>
                        <Col span={4}>{translate("产品")}</Col>
                        <Col span={4}>{translate("参考编号(大写)")}</Col>
                        <Col span={4}>{translate("状态")}</Col>
                        <Col span={4}>{translate("优惠")}</Col>
                        <Col span={4}>{translate("备注")}</Col>
                    </Row>

                    {historyList?.length > 0 && Array.isArray(historyList) &&
                        historyList.map((item, i) => {
                            return (
                                <Row
                                    style={{
                                        fontSize: "14px",
                                    }}
                                    key={i}
                                >
                                    <React.Fragment>
                                        <Col span={4}>
                                            {moment(
                                                new Date(
                                                    item.createdDate
                                                )
                                            ).format(
                                                "YYYY-MM-DD"
                                            )}
                                        </Col>
                                        <Col span={4}>
                                            {item.bonusName}
                                        </Col>
                                        <Col span={4}>
                                            {
                                                item.referenceOutId
                                            }
                                        </Col>
                                        <Col span={4}>
                                            {
                                                item.bonusStatus
                                            }
                                        </Col>
                                        <Col span={4}>
                                            {
                                                item.bonusGivenType
                                            }
                                        </Col>
                                        {item?.bonusDailyDealsDetail ? (
                                            <Col
                                                span={4}
                                                onClick={() => {
                                                    console.log("selectedItem", item);
                                                    this.setState({
                                                        selectedRecordItem: item,
                                                        showBonusDetailModal: true,
                                                    });
                                                }}
                                                style={{
                                                    color: "#00a6ff",
                                                    textDecoration: "underline",
                                                    textUnderlineOffset: "2px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                {/* {item?.bonusDailyDealsDetail?.remark} */}
                                                {translate("查看更多bonus")}
                                            </Col>
                                        ) : (
                                            "--"
                                        )}
                                    </React.Fragment>
                                </Row>
                            );
                        })
                    }
                    
                    {historyList?.length == 0 && 
                        <Col span={24} style={{marginTop:"200px"}}>
                            <Empty
                                image={"/vn/img/icon/img-no-record.svg"}
                                className="big-empty-box"
                                description={translate("红利兑换纪录数据为空")}
                            />
                        </Col>
                    }
                </div>
                {this.state.selectedRecordItem && (<AppliedDataModal
                    isVisible={this.state.showBonusDetailModal}
                    onCancel={() => {
                        this.setState({ showBonusDetailModal: false });
                    }}
                    appliedItem={this.state.selectedRecordItem}
                    title={translate("奖励信息")}
                />)}
                {this.state.showDateRangeModal && <DateRange
                    classNameDatePicker="rebate-time-picker-container"
                    classNameModal="rebate-time-picker-modal promotion-modal"
                    visible={this.state.showDateRangeModal}
                    // forDailyGiftHistory={true}
                    dateRangeLimit={6}
                    closeRange={() => {
                        this.setState({ showDateRangeModal: false });
                    }}
                    setDate={(v) => {
                        console.log("setDate v: ", v);
                        this.setState(
                            {
                                definedDate: v,
                                showDateRangeModal: false,
                                dateRadio: "0",
                                isSelfDefined:true
                            },
                            () => {
                                this.getDailydealsHistory();
                            }
                        );
                    }}
                />}
            </div>
        );
    }
}

export default BonusHistory;